import type { AxiosInstance } from 'axios';
import type { ApiPaginationResponse, ApiResponse } from '@/types';
import type { CreateMenuItem, GetAuthorityMenuListQuery, GetMenuListResponse } from '@/types/api/menu.type';

export type NewMenuApiApi = ReturnType<typeof newMenuApi>;
export default function newMenuApi(ai: AxiosInstance) {
  // 分页获取基础menu列表
  function getMenuList<D extends GetMenuListResponse, R extends ApiPaginationResponse<D>>() {
    return ai.get<R>('/api/v2/sysMenu/tree');
  }

  function getCurrentRoleMenu<D extends GetMenuListResponse, R extends ApiPaginationResponse<D>>() {
    // return ai.get<R>('/api/v2/getMenu');
    return ai.get<R>('/api/v2/sysUser/getMenu');
  }

  function getAuthorityMenuList<D extends GetMenuListResponse, R extends ApiPaginationResponse<D>>(params: GetAuthorityMenuListQuery) {
    return ai.get<R>('/api/v2/sysRole/getPermissions', { params });
  }

  function deleteMenu<D extends Record<string, never>, R extends ApiResponse<D>>(id: string) {
    return ai.post<R>('/api/v2/sysMenu/delete', { id }, { headers: { 'Content-Type': 'multipart/form-data' } });
  }

  // 新增菜单
  function createMenu<D extends Record<string, never>, R extends ApiResponse<D>>(menu: CreateMenuItem) {
    return ai.post<R>('/api/v2/sysMenu/create', menu, { headers: { 'Content-Type': 'multipart/form-data' } });
  }

  return {
    getMenuList,
    getCurrentRoleMenu,
    deleteMenu,
    getAuthorityMenuList,
    createMenu
  };
}
